import CustomArrayChipField from "components/CustomArrayChipField";
import React from "react";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  ListProps,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { Helmet } from "react-helmet";
import StatusField from "../../components/StatusField";

const UserFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <ReferenceInput
      label="Role"
      source="RoleId"
      filter={{ IsOnlyForAdmin: true }}
      reference="roles"
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const UserList = (props: ListProps) => (
  <>
    <Helmet>
      <title>Users</title>
    </Helmet>
    <List
      exporter={false}
      filters={<UserFilter />}
      filter={{ Status: "Active" }}
      bulkActionButtons={false}
      {...props}
    >
      <Datagrid rowClick="show">
        <TextField source="id" />
        <TextField source="email" label="Email" />
        <CustomArrayChipField source="roles" chipSource="name" label="Roles" />
        <StatusField label="Status" source="admin.status" />
      </Datagrid>
    </List>
  </>
);

export default UserList;
